export default __webpack_public_path__ + "static/media/ico-money.82fe1cd0.svg";